import React from 'react';
import {
    Button,
    Col,
    Form,
    FormFeedback,
    FormGroup,
    Input,
    Label,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
    Row,
} from 'reactstrap';
import './SurveyModal.scss';
import ResourceComponent from '../../common/ResourceComponent';
import * as actions from './EmbeddableApi';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';

class SurveyModal extends ResourceComponent {
    state = {
        resource: {
            method: null,
            response: '',
            validationErrors: {},
        },
    };

    handleSubmit = e => {
        this.onSubmit(e, resource => {
            this.saveSurveyAnswer(resource);
        });
    };

    saveSurveyAnswer = answer => {
        const params = {...answer, client_id: this.props.profile.client_id};
        this.props.actions.saveSurveyAnswer(params, this.props.onCancel);
    };

    setMethod = method => this.setState({resource: {...this.state.resource, method, validationErrors: {}}});

    render() {
        const {resource} = this.state;
        this.validationState('method', this.requiredValidator);

        return (
            <Modal isOpen backdrop className='survey-modal'>
                <ModalHeader>
                    How did you hear about us?
                </ModalHeader>
                <ModalBody>
                    <p>
                        We are always looking to improve our marketing efforts and reach more people like you. Please
                        take a moment to tell us how you discovered our products/services.
                    </p>
                    <Form>
                        <FormGroup row>
                            <Col>
                                <Row>
                                    <Input
                                        type='radio'
                                        checked={resource.method === 'google_search'}
                                        onChange={() => this.setMethod('google_search')}
                                    />
                                    <Label onClick={() => this.setMethod('google_search')}>Google Search</Label>
                                </Row>
                                <Row>
                                    <Input
                                        type='radio'
                                        checked={resource.method === 'instagram'}
                                        onChange={() => this.setMethod('instagram')}
                                    />
                                    <Label onClick={() => this.setMethod('instagram')}>Instagram</Label>
                                </Row>
                                <Row>
                                    <Input
                                        type='radio'
                                        checked={resource.method === 'pinterest'}
                                        onChange={() => this.setMethod('pinterest')}
                                    />
                                    <Label onClick={() => this.setMethod('pinterest')}>Pinterest</Label>
                                </Row>
                                <Row>
                                    <Input
                                        type='radio'
                                        checked={resource.method === 'article'}
                                        onChange={() => this.setMethod('article')}
                                    />
                                    <Label onClick={() => this.setMethod('article')}>Read an article</Label>
                                </Row>
                            </Col>
                            <Col>
                                <Row>
                                    <Input
                                        type='radio'
                                        checked={resource.method === 'referral'}
                                        onChange={() => this.setMethod('referral')}
                                    />
                                    <Label onClick={() => this.setMethod('referral')}>Referral</Label>
                                </Row>
                                <Row>
                                    <Input
                                        type='radio'
                                        checked={resource.method === 'word_of_mouth'}
                                        onChange={() => this.setMethod('word_of_mouth')}
                                    />
                                    <Label onClick={() => this.setMethod('word_of_mouth')}>Word of mouth</Label>
                                </Row>
                                <Row>
                                    <Input
                                        type='radio'
                                        checked={resource.method === 'youtube'}
                                        onChange={() => this.setMethod('youtube')}
                                    />
                                    <Label onClick={() => this.setMethod('youtube')}>YouTube</Label>
                                </Row>
                                <Row>
                                    <Input
                                        type='radio'
                                        checked={resource.method === 'other'}
                                        onChange={() => this.setMethod('other')}
                                    />
                                    <Label onClick={() => this.setMethod('other')}>Other</Label>
                                    {resource.method === 'other' && <Input
                                        type='textarea'
                                        invalid={this.validationState('response', this.requiredValidator)}
                                        value={resource.response}
                                        onChange={this.onTextChange('response')}
                                    />}
                                </Row>
                            </Col>
                        </FormGroup>
                        {this.state.submitted && resource.validationErrors && resource.validationErrors.method &&
                            <FormFeedback style={{display: 'block'}}>
                                Method {resource.validationErrors.method}
                            </FormFeedback>}
                    </Form>
                </ModalBody>
                <ModalFooter>
                    <Button size='sm' className='mr-2' color='warning' onClick={this.props.onCancel}>
                        Cancel
                    </Button>
                    <Button type='submit' size='sm' color='success' onClick={this.handleSubmit}>
                        Submit
                    </Button>
                </ModalFooter>
            </Modal>
        );
    };
}

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(actions, dispatch),
});

const mapStateToProps = ({appState}) => ({
    profile: appState.profile,
});

export default connect(mapStateToProps, mapDispatchToProps)(SurveyModal);


// WEBPACK FOOTER //
// ./src/containers/embeddable/SurveyModal.js